import calcCharacteristicIncrease from '../helpers/calcCharacteristicIncrease'
import calcCurrentCharacteristic from '../helpers/calcCurrentCharacteristic'
//----------------------------
// calc characteristic values
//----------------------------
export default function calcCharacteristicValues({ pfx, character }) {
  console.log('------------------------')
  console.log('IN calcCharacteristicValues')
  // adj totals (and reasons) calc'd in separate methods in this module - called from adj view
  //-----------------------------
  // set characteristic cur parm
  //-----------------------------
  let cur_parm = []
  //----------------------------------------
  // set calc current char parm - where pow
  //----------------------------------------
  // console.log('calculating current for pfx = ', pfx, ' for character = ', character);
  if (pfx == 'pow') {
    cur_parm = {
      rolled: character[pfx + '_rolled'],
      integs_tot: character[pfx + '_integs_tot'],
      improvs_tot: character[pfx + '_improvs_tot'],
      adjs_tot: character[pfx + '_adjs_tot'],
    }
  } else if (pfx == 'con') {
    cur_parm = {
      rolled: character[pfx + '_rolled'],
      wounds_tot: character[pfx + '_wounds_tot'],
      improvs_tot: character[pfx + '_improvs_tot'],
      adjs_tot: character[pfx + '_adjs_tot'],
    }
    //--------------------------------------------
    // set calc current char parm - where not pow
    //--------------------------------------------
  } else {
    cur_parm = {
      rolled: character[pfx + '_rolled'],
      improvs_tot: character[pfx + '_improvs_tot'],
      adjs_tot: character[pfx + '_adjs_tot'],
    }
  }
  // console.log("cur_parm = ", cur_parm);
  //---------------------
  // calc cur char value
  //---------------------
  character[pfx + '_cur'] = calcCurrentCharacteristic(cur_parm)
  if (pfx == 'dex' && character[pfx + '_cur'] < 1) {
    character[pfx + '_cur'] = 1
  }
  // console.log("character[pfx + '_cur'] = ", character[pfx + '_cur']);
  // console.log("BEFORE character[pfx + '_incr_percent'] = ", character[pfx + '_incr_percent']);
  // console.log("character[pfx + '_max'] = ", character[pfx + '_max']);
  //-------------------------
  // calc char increase %age
  //-------------------------
  const incr_parm = {
    rolled: character[pfx + '_rolled'],
    improvs_tot: character[pfx + '_improvs_tot'],
    max: character[pfx + '_max'],
  }
  // console.log("incr_parm = ", incr_parm);
  character[pfx + '_incr_percent'] = calcCharacteristicIncrease(incr_parm)
  // console.log("AFTER character[pfx + '_incr_percent'] = ", character[pfx + '_incr_percent']);

  return character
}
